// Server side sort of an analytics table: the column and direction to send to the API, and the `order`
// expected by the table. The component defines a `defaultSortColumn` computed, used until a column is clicked.
export const serverSortMixin = {
  data() {
    return {
      sortColumn: null,
      sortDirection: "desc",
    };
  },

  computed: {
    effectiveSortColumn() {
      return this.sortColumn || this.defaultSortColumn;
    },

    order() {
      const prefix = this.sortDirection === "asc" ? "" : "-";
      return `${prefix}${this.effectiveSortColumn}`;
    },
  },

  methods: {
    // Clicking the sorted column flips the direction, another column sorts on it descending
    handleSort(column) {
      if (this.effectiveSortColumn === column.field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column.field;
        this.sortDirection = "desc";
      }
    },

    resetSort() {
      this.sortColumn = null;
      this.sortDirection = "desc";
    },
  },
};
